var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { map, find, result } from 'lodash';
import classNames from 'classnames';
import { CheckboxGroup } from '@comall-backend-builder/components-basis';

var ArrayMode = function () {
  function ArrayMode() {}
  /**
   * 获取无数据状态展示组件
   */


  ArrayMode.prototype.getNotAvailableDisplayComponent = function (displayInfo) {
    var className = displayInfo.className,
        style = displayInfo.style;
    return React.createElement("span", {
      className: classNames('type-not-available', className),
      style: style
    }, "NA");
  };
  /**
   * 获取有数据状态展示组件
   */


  ArrayMode.prototype.getAvailableDisplayComponent = function (value, displayInfo) {
    var className = displayInfo.className,
        style = displayInfo.style;
    return React.createElement("span", {
      className: className,
      style: style
    }, value);
  };
  /**
   * 获取展示组件
   */


  ArrayMode.prototype.getDisplayComponent = function (array, displayInfo) {
    var className = displayInfo.className,
        style = displayInfo.style,
        options = displayInfo.options;

    if (array && array.length) {
      if (options) {
        // 通过id，查找显示的value值
        array = map(array, function (item, _index) {
          return result(find(options, function (option) {
            return option.id === String(item);
          }), 'name');
        });
      }

      return React.createElement("div", {
        className: classNames('type-array', className),
        style: style
      }, map(array, function (item, index) {
        return React.createElement("div", {
          key: index,
          className: "string-type"
        }, item);
      }));
    } else {
      return this.getNotAvailableDisplayComponent(displayInfo);
    }
  };
  /**
   * 获取输入组件
   */


  ArrayMode.prototype.getControlComponent = function (controlInfo) {
    return React.createElement(CheckboxGroup, __assign({}, controlInfo));
  };

  return ArrayMode;
}();

export { ArrayMode };